export const LIST_BRANCH_TYPE_REQUEST = 'LIST_BRANCH_TYPE_REQUEST'
export const LIST_BRANCH_TYPE_SUCCESS = 'LIST_BRANCH_TYPE_SUCCESS'
export const LIST_BRANCH_TYPE_FAIL = 'LIST_BRANCH_TYPE_FAIL'

export const CREATE_BRANCH_TYPE_REQUEST = 'CREATE_BRANCH_TYPE_REQUEST'
export const CREATE_BRANCH_TYPE_SUCCESS = 'CREATE_BRANCH_TYPE_SUCCESS'
export const CREATE_BRANCH_TYPE_FAIL = 'CREATE_BRANCH_TYPE_FAIL'

export const DETAIL_BRANCH_TYPE_REQUEST = 'DETAIL_BRANCH_TYPE_REQUEST'
export const DETAIL_BRANCH_TYPE_SUCCESS = 'DETAIL_BRANCH_TYPE_SUCCESS'
export const DETAIL_BRANCH_TYPE_FAIL = 'DETAIL_BRANCH_TYPE_FAIL'

export const UPDATE_BRANCH_TYPE_REQUEST = 'UPDATE_BRANCH_TYPE_REQUEST'
export const UPDATE_BRANCH_TYPE_SUCCESS = 'UPDATE_BRANCH_TYPE_SUCCESS'
export const UPDATE_BRANCH_TYPE_FAIL = 'UPDATE_BRANCH_TYPE_FAIL'

export const DELETE_BRANCH_TYPE_REQUEST = 'DELETE_BRANCH_TYPE_REQUEST'
export const DELETE_BRANCH_TYPE_SUCCESS = 'DELETE_BRANCH_TYPE_SUCCESS'
export const DELETE_BRANCH_TYPE_FAIL = 'DELETE_BRANCH_TYPE_FAIL'

export const RESET_BRANCH_TYPE = 'RESET_BRANCH_TYPE'